import { EU_STRIPE_PRICE_ID, STRIPE_PRICE_ID } from "../constants/formConstants";

const EU_CAMPAIGN_MARKER = "_EU_";

export const USD_TRIAL_OFFER_ID = "trial-usd-v1";
export const EUR_TRIAL_OFFER_ID = "trial-eur-v1";

export const getTrialOfferId = (currency = "usd") =>
  String(currency).toLowerCase() === "eur" ? EUR_TRIAL_OFFER_ID : USD_TRIAL_OFFER_ID;

export const CANONICAL_PAYWALL_ROUTES = [
  "/colortype-3month-29",
  "/colortype-3month-29-upsell",
  "/colortype-3month-29-upsell-v2",
  "/colortype-1month-29",
  "/glasses-3month-29-upsell-v2",
  "/sunglasses-3month-29-upsell-v2",
  "/makeup-3month-29-upsell-v2",
  "/haircolor-3month-29",
  "/haircolor-recomend-3month-29",
  "/hairstyle-3month-29-woman",
  "/bodytype-3month-29-woman",
  "/wedding-guest-3month-29-woman",
  "/hairstyle-3month-29-man",
  "/faceshape-3month-29",
  "/faceshape_3month_29",
];

const USD_TRIAL_PRICING = {
  isEuPricing: false,
  trialCost: "0.99",
  trialDisplay: "$1",
  trialValue: 0.99,
  trialValueText: "$0.99",
  trialOriginalDisplay: "$6.99",
  amount: 99,
  currency: "usd",
  offerId: USD_TRIAL_OFFER_ID,
  purchaseValue: 0.99,
  priceId: STRIPE_PRICE_ID,
  subscriptionDisclaimerPrice: "29.99$",
};

const EUR_TRIAL_PRICING = {
  isEuPricing: true,
  trialCost: "1",
  trialDisplay: "€1",
  trialValue: 1,
  trialValueText: "€1",
  trialOriginalDisplay: "€6.99",
  amount: 100,
  currency: "eur",
  offerId: EUR_TRIAL_OFFER_ID,
  purchaseValue: 1,
  priceId: EU_STRIPE_PRICE_ID,
  subscriptionDisclaimerPrice: "29.90€",
};

export const isCanonicalPaywallRoute = (pathname = "") =>
  CANONICAL_PAYWALL_ROUTES.includes(pathname);

export const hasEuCampaignMarker = (search = "") => {
  const params = new URLSearchParams(search || "");
  return params.getAll("utm_campaign").some((value) => value.includes(EU_CAMPAIGN_MARKER));
};

export const getPaywallPricingContext = (pathname = "", search = "") => {
  if (isCanonicalPaywallRoute(pathname) && hasEuCampaignMarker(search)) {
    return EUR_TRIAL_PRICING;
  }

  return USD_TRIAL_PRICING;
};
